export enum EtaType {
  donorOR = 'donorOR',
  txCenterSta = 'txCenterSta',
  txCenterEta = 'txCenterEta',
  txCenterOr = 'txCenterOr',
  delay = 'delay',
}

export type EtaContent = {
  type: EtaType;
  label: string;
};
